var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"63.5 4.99 54.87 0 54.87 4.49 0 4.49 0 5.49 54.87 5.49 54.87 9.97 63.5 4.99"}));
}

Arrow.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 63.5 9.97"};

module.exports = Arrow;

Arrow.default = Arrow;
